import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import {
	ANCHOR_STATUS,
	useAnchorGeneratedFamiliesReviewMutation,
} from '@/entities/anchor'

import { Operators } from '@/shared/components/query-builder'
import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'
import { processingMessage } from '@/shared/tools/message'

export const useRejectAnchorFamily = () => {
	const { t } = useTranslation()

	const anchorGeneratedFamiliesReviewMutation =
		useAnchorGeneratedFamiliesReviewMutation({
			onSuccess: () => {
				queryClient.refetchQueries({
					queryKey: ['generated-anchor-families'],
				})
			},
		})
	const handleRejectAnchorFamily = useCallback(
		(id: string) => {
			ampli.anchoringAnchorApprovalClickReject()
			toast.promise(
				anchorGeneratedFamiliesReviewMutation.mutateAsync({
					filters: [
						{
							name: 'id',
							operation: Operators.IS,
							value: id,
						},
					],
					status: ANCHOR_STATUS.REJECTED,
				}),
				{
					loading: processingMessage(t),
					error: t('fatal_error_title'),
					success: t('toast.entity.updated', {
						entity: t('entity.anchor_family'),
					}),
					id: 'anchor_generated_family_status_updating',
				}
			)
		},
		[anchorGeneratedFamiliesReviewMutation, t]
	)

	return {
		handleRejectAnchorFamily,
		isPending: anchorGeneratedFamiliesReviewMutation.isPending,
	}
}
